const DEFAULT_CANONICAL_HOSTS = [
  "auth.feradel.com",
  "matters.feradel.com",
  "matters.clients.feradel.com",
];

function configuredHosts(extraHosts = []) {
  const configured = String(process.env.REACT_APP_ALLOWED_TENANT_HOSTS || "")
    .split(",")
    .map(value => value.trim().toLowerCase().replace(/\.$/, ""))
    .filter(Boolean);
  return new Set([...DEFAULT_CANONICAL_HOSTS, ...configured, ...extraHosts]);
}

export function isSafeTenantUrl(value, { allowedHosts = [], allowLocalhost = process.env.NODE_ENV !== "production" } = {}) {
  if (typeof value !== "string" || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    const hostname = url.hostname.toLowerCase().replace(/\.$/, "");
    const local = allowLocalhost && (hostname === "localhost" || hostname === "127.0.0.1");
    if ((!local && url.protocol !== "https:") || (local && !["http:", "https:"].includes(url.protocol))) return false;
    if (url.username || url.password || url.port || url.search || url.hash || !hostname) return false;
    if (!local && (!hostname.includes(".") || !configuredHosts(allowedHosts).has(hostname))) return false;
    return true;
  } catch (_error) {
    return false;
  }
}

export function safeTenantBaseUrl(value, options = {}) {
  if (!isSafeTenantUrl(value, options)) return null;
  const url = new URL(value.trim());
  return `${url.origin}${url.pathname.replace(/\/+$/, "")}`;
}

export function safeTokenizeRedirect({ destination, instance, args = "", token, next = null, allowedHosts = [] }) {
  const base = safeTenantBaseUrl(destination, { allowedHosts });
  if (!base || !instance || !token) return null;
  const params = new URLSearchParams(args || "");
  params.set("i", instance);
  params.set("t", token);
  if (next) params.set("next", next);
  return `${base}/authentic/tokenize?${params.toString()}`;
}

